import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import Head from "next/head";
const StructuredData = ({
  data
}) => /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx(
  "script",
  {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(data)
    }
  }
) });
StructuredData.propTypes = {
  data: PropTypes.shape({})
};
export {
  StructuredData as default
};
